import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchInsightData, fetchKeywordAddDel } from './thunk/insightThunk';
import { addDelKeywordParamsType } from '@models/keyword/keywordModel';

// TODO: 타입지정은 백엔드 사양 확정 후 진행할것..
type paramsType = {
  appList;
  country;
};

const initialState = {
  params: null as paramsType,
  keywordList: null,
};

export const keywordInsightSlice = createSlice({
  name: 'keywordInsight',
  initialState: initialState,
  reducers: {
    setParams: (state, { payload }) => {
      state.params = payload;
    },
    // keywordInsightSlice 의 searchAppComponent 에서 리스트 변경시 keywordList 데이터 초기화 처리
    // 재요청하여 데이터 가져오도록 변경하기
    setKeywordList: (state, { payload }) => {
      state.keywordList = null;
    },
  },
  extraReducers: {
    // suggestion GridData
    [fetchInsightData.fulfilled.type]: (state, { payload }) => {
      state.keywordList = payload;
    },
    // keyword Add/Del
    [fetchKeywordAddDel.fulfilled.type]: (state, { payload }: { payload: addDelKeywordParamsType }) => {
      const { keyword, userId, reqType } = payload;
      console.log('payload7777: ', payload);
      // 기존 데이터 변경처리
      const objIndex = state.keywordList.findIndex((item) => item.keyword === keyword);
      // 아래는 기존 searchBox 데이터 변경로직
      if (reqType === 'add') {
        // request가 add 이므로 del 로 바꿔야 한다.(true)
        state.keywordList[objIndex].tracked = true;
      } else if (reqType === 'del') {
        // request가 del 이므로 add로 바꿔야 한다.(false)
        state.keywordList[objIndex].tracked = false;
      }
    },
  },
});

export const { setParams, setKeywordList } = keywordInsightSlice.actions;
export const keywordInsightSliceName = keywordInsightSlice.name;
export default keywordInsightSlice.reducer;
